// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/img/backgrounds/jungle_light.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html, body { /* @TODO: this is a little bit hacky because i don't know what's causing the overflow issue (it's only a problem on mobile...and it's like 5px on the right and the bottom) */
  overflow-x: hidden;
}

body {
  margin: 0;
  font-family: 'Ubuntu', 'Montserrat', 'Helvetica Neue', sans-serif;
  font-size: 18px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* @TODO: background: linear-gradient(-217deg, #cccccc, #00000088); */
  background-color: #002d3d; /* @TODO: make this dynamic based on theme and dark mode */
  background-image: linear-gradient(
    #ffffffcc 0%,
    #ffffffee 100%
  ), url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-attachment: fixed;
  background-size: cover;
  background-repeat: no-repeat;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

/* @TODO: these shouldn't affect material ui...admin menu and nav items */
/* @TODO:
a:link { /* unvisted /
  color: #82afff;
}
a:visited {
  color: #2a62b0;
}
a:hover {
  color: #8ab200;
}
a:active {
  color: #c6ff00;
}
*/
`, "",{"version":3,"sources":["webpack://./src/index/index.css"],"names":[],"mappings":"AAAA,aAAa,6KAA6K;EACxL,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,iEAAiE;EACjE,eAAe;EACf,mCAAmC;EACnC,kCAAkC;EAClC,qEAAqE;EACrE,yBAAyB,EAAE,0DAA0D;EACrF;;;4CAGoD;EACpD,4BAA4B;EAC5B,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE;aACW;AACb;;AAEA,yEAAyE;AACzE;;;;;;;;;;;;;CAaC","sourcesContent":["html, body { /* @TODO: this is a little bit hacky because i don't know what's causing the overflow issue (it's only a problem on mobile...and it's like 5px on the right and the bottom) */\n  overflow-x: hidden;\n}\n\nbody {\n  margin: 0;\n  font-family: 'Ubuntu', 'Montserrat', 'Helvetica Neue', sans-serif;\n  font-size: 18px;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  /* @TODO: background: linear-gradient(-217deg, #cccccc, #00000088); */\n  background-color: #002d3d; /* @TODO: make this dynamic based on theme and dark mode */\n  background-image: linear-gradient(\n    #ffffffcc 0%,\n    #ffffffee 100%\n  ), url(\"../assets/img/backgrounds/jungle_light.png\");\n  background-attachment: fixed;\n  background-size: cover;\n  background-repeat: no-repeat;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n/* @TODO: these shouldn't affect material ui...admin menu and nav items */\n/* @TODO:\na:link { /* unvisted /\n  color: #82afff;\n}\na:visited {\n  color: #2a62b0;\n}\na:hover {\n  color: #8ab200;\n}\na:active {\n  color: #c6ff00;\n}\n*/\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
